import { useState, useEffect, useRef } from 'react';
import './HeroCarousel.css';
import { Link } from 'react-router-dom';
import OptimizedImage from './OptimizedImage';

const carouselData = [
  {
    id: 1,
    title: 'Innovate & Transform',
    subtitle: 'Next-Gen Digital Solutions',
    description: 'Empowering businesses with cutting-edge technology solutions. From AI-driven applications to cloud-native architectures, we turn your vision into digital reality.',
    cta: 'Start Your Journey',
    image: '/images/hero/digital-transformation.jpg',
    link: '/contact'
  },
  {
    id: 2,
    title: 'Build & Scale',
    subtitle: 'Future-Ready Applications',
    description: 'Create scalable, high-performance applications that drive business growth. Our expert team delivers robust solutions using the latest tech stack and best practices.',
    cta: 'Let\'s Build Together',
    image: '/images/hero/software-development.jpg',
    link: '/services'
  },
  {
    id: 3,
    title: 'Learn & Grow',
    subtitle: 'Expert-Led Training Programs',
    description: 'Accelerate your tech career with our industry-focused training programs. Master in-demand skills with hands-on projects and personalized mentoring.',
    cta: 'Explore Programs',
    image: '/images/hero/cloud-computing.jpg',
    link: '/training'
  },
  {
    id: 4,
    title: 'Secure & Protect',
    subtitle: 'Advanced Cybersecurity',
    description: 'Safeguard your digital assets with our comprehensive security solutions. From zero-trust architecture to 24/7 threat monitoring, we\'ve got you covered.',
    cta: 'Secure Your Business',
    image: '/images/hero/software-development.jpg',
    link: '/services/security'
  },
  {
    id: 5,
    title: 'Analyze & Optimize',
    subtitle: 'Data Intelligence Solutions',
    description: 'Transform raw data into actionable insights. Our AI and analytics solutions help you make data-driven decisions for business growth and optimization.',
    cta: 'Unlock Insights',
    image: '/images/hero/cloud-computing.jpg',
    link: '/services/data'
  }
];

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const imageRefs = useRef([]);

  useEffect(() => {
    const timer = setInterval(() => {
      handleNextSlide();
    }, 3000);
    return () => clearInterval(timer);
  }, [currentSlide]);

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselData.length);
  };

  return (
    <div className="hero-carousel">
      {carouselData.map((slide, index) => (
        <div
          key={index}
          className={`hero-slide ${currentSlide === index ? 'active' : ''}`}
        >
          <div 
            className="hero-slide-bg"
            ref={el => imageRefs.current[index] = el}
          >
            <OptimizedImage
              src={slide.image}
              alt={slide.title}
              type="hero"
              loading={index === 0 ? 'eager' : 'lazy'}
              className="hero-image"
            />
          </div>
          <div className="hero-slide-pattern" />
          <div className="hero-content">
            <div className="hero-content-wrapper">
              {/* <h1>{slide.title}</h1> */}
              <h1>{slide.subtitle}</h1>
              <p>{slide.description}</p>
              <Link to={slide.link} className="btn btn-primary">
                {slide.cta}
              </Link>
            </div>
          </div>
        </div>
      ))}
      <div className="carousel-controls">
        <div className="carousel-dots">
          {carouselData.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroCarousel;
